import { Navigate, Route, Routes } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';
import { ApiKeysPage } from '@/modules/api-keys';
import { AuthLoader } from '@/modules/auth/components/AuthLoader';
import { NonDemoFirewall } from '@/modules/auth/components/NonDemoFirewall';
import { ChangelogPage } from '@/modules/changelog';
import { ImportExportPage, VaultImportModal } from '@/modules/import-export/components';
import { Layout, MainSection, SideSection, UpgradeNotice } from '@/modules/layout';
import { NewSecretPage, SecretDetailPage, SecretsPage, SecurityAuditSecretsPage, UpdateSecretPage } from '@/modules/secrets';
import { SecurityAuditGraphRoutes } from '@/modules/security-audit';
import {
    GroupsVisibilitySettings,
    Settings,
    SettingsPage,
    SubscriptionFirewall,
    TagsSettings,
    VaultsSettings,
} from '@/modules/settings/components';
import { UserAdministrationPage } from '@/modules/user-administration/components';
import { VaultFirewall } from '@/modules/vaults';

import { Sidebar } from '../Sidebar';

export const ResponsiveApplication = () => (
    <Layout>
        <SubscriptionFirewall>
            <MainSection>
                <UpgradeNotice>
                    <Sidebar />
                    <Routes>
                        <Route path={config.routes.secrets} element={<SecretsPage />} />
                        <Route
                            path={config.routes.vault}
                            element={
                                <VaultFirewall>
                                    <SecretsPage />
                                </VaultFirewall>
                            }
                        />
                        {[
                            config.routes.updateSecret,
                            config.routes.securityAuditUpdateSecret,
                            config.routes.securityAuditLevelUpdateSecret,
                            config.routes.securityAuditAgeUpdateSecret,
                            config.routes.securityAuditLeaksUpdateSecret,
                        ].map(route => (
                            <Route key={route} path={route} element={<UpdateSecretPage />} />
                        ))}
                        <Route path={config.routes.newSecret} element={<NewSecretPage />} />
                        <Route path={config.routes.secret} element={<SecretDetailPage />} />

                        {[
                            config.routes.securityAudit,
                            config.routes.securityAuditLevel,
                            config.routes.securityAuditAge,
                            config.routes.securityAuditLeaks,
                        ].map(route => (
                            <Route key={route} path={route} element={<SecurityAuditSecretsPage />} />
                        ))}

                        <Route path={config.routes.importExport} element={<ImportExportPage />} />

                        <Route path={config.routes.changelog} element={<ChangelogPage />} />

                        <Route path={config.routes.settings} element={<SettingsPage />}>
                            <Route path={config.routes.settings} element={<Settings />} />
                            <Route path={config.routes.tagsSettings} element={<TagsSettings />} />
                            <Route path={config.routes.groupsVisibilitySettings} element={<GroupsVisibilitySettings />} />
                        </Route>
                        {/* Outside `SettingsPage` on purpose: its admin firewall would turn away the vault
                            editors this page exists for. */}
                        <Route
                            path={config.routes.vaultsSettings}
                            element={
                                <NonDemoFirewall>
                                    <VaultsSettings />
                                </NonDemoFirewall>
                            }
                        />

                        <Route path={config.routes.userAdministration} element={<UserAdministrationPage />} />

                        <Route path={config.routes.apiKeys} element={<ApiKeysPage />} />

                        <Route path={config.googleOAuth.redirectUrl} element={<AuthLoader />} />

                        <Route path='*' element={<Navigate to={config.routes.secrets} replace />} />
                    </Routes>
                    {/* Opened from a vault's actions in the records list; lives here because the vaults
                        module cannot reach the import flow without a cycle. */}
                    <VaultImportModal />
                </UpgradeNotice>
            </MainSection>
            <SideSection>
                <SecurityAuditGraphRoutes />
            </SideSection>
        </SubscriptionFirewall>
    </Layout>
);
